<!--
 * @Description: 服务区车辆 客流 事件统计
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-18 11:38:37
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-03-29 16:55:18
 -->
<template>
  <div class="serviceAreaCount">
    <div class="item">
      <img src="/static/img/layout/cars.png" alt="">
      <div class="label">车流统计总数</div>
      <div class="value">{{serviceAreaCountData.carFlow}}</div>
    </div>
    <div class="item">
      <img src="/static/img/layout/passenger.png" alt="">
      <div class="label">客流统计总数</div>
      <div class="value">{{serviceAreaCountData.peopleFlow}}</div>
    </div>
    <div class="item">
      <img src="/static/img/layout/AI-event.png" alt="">
      <div class="label">AI识别事件总数</div>
      <div class="value">{{serviceAreaCountData.aiEvent}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'serviceAreaCount',
  components: {
  },
  data () {
    return {
      serviceAreaCountData: {},
    }
  },
  methods: {
    /**
     * @description                   获取部署数据
     * @param   {String}              请求地址
     * @param   {type}                请求标志-区分里程还是时间
     * @return {undefied}             无返回值
     */
    getData (url, type) {
      this.$http.get('/rest/screen/zhfwq/right-top/summary')
        .then(res => {
          if (res.code === 0) {
            this.serviceAreaCountData = res.data
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
  },
  created () {
    this.getData()
  },
}
</script>

<style lang="less" scoped>
  .serviceAreaCount {
    width: 100%;
    height: 100%;
    background: url('/static/img/layout/listBg.png');
    background-size: 100% 100%;
    display: inline-flex;
    justify-content: space-around;
    align-items: center;
    .item {
      width: 33%;
      text-align: center;
      color: #fff;
      img {
        height: 4vh;
      }
      .label {
        font-size: 1.5vh;
        line-height: 2.6vh;
      }
      .value {
        font-size: 1.8vh;
        line-height: 3vh;
        font-weight: bold;
      }
    }
  }
</style>
